import React from "react";
import { Route, Switch } from "react-router-dom";

//Import components 

import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from './containers/Login';
// import AppliedRoute from "./components/AppliedRoute";
import Signup from "./containers/Signup";
import CreateTopic from "./containers/topics/createTopic";
import CreateVideo from "./containers/Animations/createVideo"
// import CreateReport from "./containers/CreateReport";
// import DownloadData from "./containers/DownloadData";
// import TextUsers from "./containers/TextUsers";
import AffiliatedGroups from "./containers/Organization/getOrganization";
import GetTopics from "./containers/topics/getTopics";
import Videos from "./containers/Animations/getVideo";
import ActivityView from "./containers/Activities/activityView";
import PushNotifications from "./containers/PushNotifications/pushNotifications"

import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

export default ({ childProps }) =>
<Switch>
  <AuthenticatedRoute path="/" exact component={Home} props={childProps} />
  <UnauthenticatedRoute    path="/login" exact component={Login} props={childProps} />
  <UnauthenticatedRoute    path="/signup" exact component={Signup} props={childProps} />
  <AuthenticatedRoute   path="/topics/new" exact component={CreateTopic} props={childProps} />
  <AuthenticatedRoute   path="/videos/new" exact component={CreateVideo} props={childProps} />
  {/* <AppliedRoute path="/createreport" exact component={CreateReport} props={childProps} /> */}
  {/* <AppliedRoute path="/downloaddata" exact component={DownloadData} props={childProps} /> */}
  {/* <AppliedRoute path="/textusers" exact component={TextUsers} props={childProps} /> */}
  <AuthenticatedRoute   path="/affiliatedgroups" exact component={AffiliatedGroups} props={childProps} />
  <AuthenticatedRoute   path="/topics" exact component={GetTopics} props={childProps} />
  <AuthenticatedRoute   path="/videos" exact component={Videos} props={childProps} />
  <AuthenticatedRoute   path="/viewdata" exact component={ActivityView} props={childProps} />
  <AuthenticatedRoute   path="/pushNotifications" exact component={PushNotifications} props={childProps} />
  



  { /* Finally, catch all unmatched routes */ }
  <Route component={NotFound} />
</Switch>;